module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("Dawit was born and brought up in Asmara, Eritrea. After completing high school in his homeland, he left for Italy at a young age. He accumulated years of experience in various fields; among these, he was privileged to travel as a sailor across the world, which fueled his vivid and colorful imagination. ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("Despite not having undertaken any formal writing courses, Dawit mulled over "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Long Dark Trail")]), _vm._v(" (formerly known as "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Verdict of Time")]), _vm._v(") for decades, taking inspiration from his many personal experiences as well as from books, films, travels, folklore, people and nature. ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("Dawit first wrote the story in Tigrigna, his native language. He then proceeded to collaborate with an esteemed group of translators to work on the Amharic and English versions simultaneously. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57ae8e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781528957960_EPUB.vue
// module id = 57
// module chunks = 0